import React, {useEffect, useState} from 'react';
import './scss/process-view.scss';
import {Button} from 'react-bootstrap';
import ProcessModel from '../models/process';
import FullScreenLoader from './full-screen';
import ProcessItem from './process-item';
import PasswordDialog from './password-dialog';
import StatusProp from './properties/status';
import MessageDialog from './message-dialog';
import Error from './error';
import SandraJsAPI from "../services/sandraJsAPI";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function ProcessView({setStatusMessage}: StatusProp): React.ReactElement {
    const urlParams = new URLSearchParams(window.location.search);
    const processId = String(urlParams.get('id'));
    const processInit: ProcessModel = {
        id: '',
        status: '',
        processTitle: '',
        addresses: [],
        lastStopTime: '',
        processID: '',
        lastStartTime: '',
        blockchain: '',
        processDescription: '',
        appName: '',
        monitor: {
            memory: 0,
            cpu: 0
        }
    };

    const [process, setProcess] = useState(processInit);
    const [isLoading, setIsLoading] = useState(false);
    const [isPosting, setIsPosting] = useState(false);
    const [passModalShow, setPassModalShow] = React.useState(false);
    const [messageModalShow, setMessageModalShow] = React.useState(false);
    const [jetskiAction, setJetskiAction] = React.useState('');
    const [dialogMessage, setDialogMessage] = React.useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const handlePasswordSubmit = (phrase: string) => {
        setIsPosting(true);
        setPassModalShow(false);
        SandraJsAPI.doProcessAction(process.id, process.blockchain, phrase, jetskiAction).then((result) => {
            setIsPosting(false);
            if (result.error) {
                window.scrollTo(0, 0);
                setStatusMessage(result.error.message, StatusMessageTypeEnum.error);
                return;
            }
            setDialogMessage('Action completed!');
            setMessageModalShow(true);
        }).catch((reason) => {
            window.scrollTo(0, 0);
            setIsPosting(false);
            setStatusMessage(reason.message, StatusMessageTypeEnum.error);
        });
    };

    const handleOnClick = (event: any, data: any) => {
        event.preventDefault();
        setStatusMessage('', StatusMessageTypeEnum.none);
        setJetskiAction(data);
        setPassModalShow(true);
    };

    useEffect(() => {
        setIsLoading(true);
        SandraJsAPI.getJetskiProcess((processId))
            .then((result) => {
                if (result.error) {
                    setErrorMessage(result.error.message);
                } else {
                    setProcess(result.data);
                }
                setIsLoading(false);
            })
            .catch((reason) => {
                setErrorMessage(reason.message);
                setIsLoading(false);
            });
    }, []);
    const status = process?.status === 'running' ? 'running' : 'stopped';

    const startView = status === 'running'
        ? (
            <div>
                <Button
                    onClick={((e) => handleOnClick(e, 'stop'))}
                    className="btn btn-danger"
                    style={{letterSpacing: '1px', padding: '.25rem 1rem', fontSize: '12px'}}
                >
                    Stop
                </Button>
                <Button
                    onClick={((e) => handleOnClick(e, 'restart'))}
                    className="btn btn-danger"
                    style={{
                        letterSpacing: '1px', padding: '.25rem 1rem', fontSize: '12px', marginLeft: '.5rem',
                    }}
                >
                    Restart
                </Button>
            </div>
        )
        : (
            <Button
                onClick={((e) => handleOnClick(e, 'start'))}
                className="btn btn-light fw-bold"
                style={{
                    letterSpacing: '1px',
                    padding: '.25rem 1rem',
                    fontSize: '12px',
                    backgroundColor: "rgb(255, 245, 230)"
                }}
            >
                Start
            </Button>
        );

    let pageView = <div/>;

    if (errorMessage) {
        pageView = <Error header="Oops! Server says" description={errorMessage}/>;
    } else {
        pageView = (
            <div>
                <PasswordDialog
                    action={jetskiAction}
                    show={passModalShow}
                    onHide={() => {
                        setPassModalShow(false);
                    }}
                    onSubmit={handlePasswordSubmit}
                />
                <MessageDialog
                    title="Process Status"
                    message={dialogMessage}
                    show={messageModalShow}
                    onHide={() => {
                        setMessageModalShow(false);
                    }}
                />
                <h5 className="d-inline-block text-uppercase pt-1 ps-1 ">Jetski Process</h5>
                <ProcessItem process={process}/>
                <div className="loading-wrapper text-end">
                    {startView}
                    {isPosting ? <FullScreenLoader/> : <div></div>}
                </div>
                {process?.id.indexOf("_canonize") >= 0 ? (<div>
                    <table className="table  table-striped">
                        <thead>
                        <tr>
                            <th>Address</th>
                            <th>Status</th>
                        </tr>
                        </thead>
                        <tbody>
                        {process?.addresses?.map((address, index) => (
                            <tr key={index}>
                                <td>
                                    <a href={`/contract?hash=${address.hash}`}>
                                        {address.hash}
                                    </a>
                                </td>
                                <td>
                                    {address.status}
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>) : (<div></div>)}

            </div>
        );
    }
    return (
        <div className="pt-3 loading-wrapper">
            {isLoading ? <FullScreenLoader/>
                : pageView}
        </div>
    );
}

export default ProcessView;
